import { render } from "./signPrivacyAgreement.vue?vue&type=template&id=be2d3b8a"
import script from "./signPrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./signPrivacyAgreement.vue?vue&type=script&lang=js"

import "./signPrivacyAgreement.vue?vue&type=style&index=0&id=be2d3b8a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__